import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const GalleryStats = ({ projects, activeCategory }) => {
  const filteredProjects = activeCategory === 'All' 
    ? projects 
    : projects?.filter(p => p?.category === activeCategory);

  const stats = [
    {
      icon: 'Folder',
      label: 'Projects',
      value: filteredProjects?.length,
      color: 'text-accent'
    },
    {
      icon: 'Users',
      label: 'Clients',
      value: new Set(filteredProjects.map(p => p.client))?.size,
      color: 'text-cosmic-energy'
    },
    {
      icon: 'Code',
      label: 'Technologies',
      value: new Set(filteredProjects.flatMap(p => p.technologies))?.size,
      color: 'text-cosmic-cta'
    },
    {
      icon: 'Star',
      label: 'Avg Rating',
      value: (filteredProjects?.reduce((acc, p) => acc + parseFloat(p?.rating), 0) / filteredProjects?.length)?.toFixed(1),
      color: 'text-warning'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats?.map((stat, index) => (
        <motion.div
          key={stat?.label}
          className="glass-panel rounded-lg p-4 text-center cosmic-glow-hover"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <div className="flex items-center justify-center mb-2">
            <div className={`w-10 h-10 rounded-lg bg-surface/50 flex items-center justify-center ${stat?.color}`}>
              <Icon name={stat?.icon} size={20} />
            </div>
          </div>
          <div className="space-y-1">
            <div className={`text-2xl font-bold font-headline ${stat?.color}`}>
              {stat?.value}
            </div>
            <div className="text-sm text-muted-foreground font-body">
              {stat?.label}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default GalleryStats;